import { Point } from '../types/point'

export const isSamePoint = (point: Point, item: Point): boolean =>
  item.geolocation.lat === point.geolocation.lat && item.geolocation.lng === point.geolocation.lng

export const isVisiblePoint = (points: Point[], point: Point, isQuery: boolean): boolean =>
  !isQuery || !!points.find((item) => isSamePoint(point, item))
